import { render, staticRenderFns } from "./TranslationInput.vue?vue&type=template&id=1998394d&"
import script from "./TranslationInput.vue?vue&type=script&lang=js&"
export * from "./TranslationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports